//import lottie from 'lottie-web';


export default class WwdSections {
    
    static get selector() {
        return '.wwdSections';
    }

    constructor(el) {        
        this.el = el;
        this.items = this.getItems();
        this.items.forEach( item =>{
            this.launchAnimation(item);
        });
    }

    launchAnimation(item) {

        item.animation = lottie.loadAnimation({
            container: item.figure, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: item.animationUrl, // the path to the animation json
        });
        

        item.el.classList.add('wwdSections__item--animated');
        item.hasAnimation = true;
    }

    getItems() {
        let items = [];
        let elements = this.el.querySelectorAll('.wwdSections__item');

        elements.forEach(el => {
            let item = {};
                item.hasAnimation = false;
                item.el = el;
                item.animationUrl = el.dataset.animation;
                item.animation = null;
                item.figure = el.querySelector('.wwdSections__image');

                items.push(item);
        });
    
        return items;
    }
    
    setEvents() {

    }
}